import clsx from 'clsx'

import {
  DynamicField,
  DynamicFieldValue,
} from 'shared/api/kyrgyzstan/search/model'
import { Paper } from 'shared/ui/paper'

import { DynamicFields } from './ui/dynamic-fields'

import s from './styles.module.scss'

interface HeadSectionProps {
  title: string
  location: string
  popularDynamicFields: DynamicField[]
  dynamicFields: DynamicFieldValue
  realtyId: string
}

export const HeadSection = ({
  title,
  location,
  popularDynamicFields,
  dynamicFields,
  realtyId,
}: HeadSectionProps) => {
  const shouldShowDynamicFields = popularDynamicFields.length > 0

  return (
    <Paper
      padding={[16, 16, 12]}
      radius="0 0 16px 16px"
    >
      <h1 className={clsx('extra-bold-16', s.title)}>{title}</h1>
      <p className={clsx('semi-bold-12', s.location)}>{location}</p>

      {shouldShowDynamicFields && (
        <DynamicFields
          popularDynamicFields={popularDynamicFields}
          dynamicFields={dynamicFields}
          realtyId={realtyId}
        />
      )}
    </Paper>
  )
}
